import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class UrlUtil {
    static addQueryParam(baseUrl: string, param: string, value: string): string {
        const url = new URL(baseUrl);
        url.searchParams.set(param, value);
        return url.toString();
    }

    static isValidUrl(value: string | null | undefined): boolean {
        const normalizedValue = value?.trim();
        if (!normalizedValue) {
            return true;
        }

        try {
            const url = new URL(normalizedValue);
            return url.protocol === 'http:' || url.protocol === 'https:';
        } catch {
            return false;
        }
    }

    static urlValidator(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null =>
            UrlUtil.isValidUrl(control.value) ? null : { url: true };
    }
}
